import { logEvent } from "@firebase/analytics";
import {Button, Checkbox, Collapse, FormControlLabel, FormGroup, Link, Paper} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GoogleLoginButton } from "react-social-login-buttons";
import { analytics } from "../../firebase/firebase";
import { useAuth } from "../../firebase/firebaseAuth";
import logo from "../../images/logo_black.png";
import { CustomLogin } from "./CustomLogin";
import {I18Picker} from "../../components/I18Picker/I18Picker";
export const Login = () => {
    const { user, signInWithGoogle } = useAuth();
    const navigate = useNavigate();
    const [colapsed, setColapsed] = useState<boolean>(true);
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState<'accepted'|'empty'|'error'>('empty');

    useEffect(() => {
        logEvent(analytics, "page_view")
    }, []);

    useEffect(() => {
        if (user) navigate("/");
    }, [user, navigate]);

    const logInWithGoogle = () => {
      if(privacyPolicyAccepted === 'accepted') {
        signInWithGoogle();
      }else{
        setPrivacyPolicyAccepted('error')
      }
    }
    const {t} = useTranslation('',{keyPrefix:'login.option'});
    return (
        <Box sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Paper elevation={8}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        m: 3
                    }}
                >
                    <Box justifyContent={"center"} mb={3}>
                        <img height={50} src={logo} alt={t('logo')||""} onClick={() => navigate("/")} />
                    </Box>
                    <GoogleLoginButton
                        onClick={() => {
                            logInWithGoogle()
                        }} text={t('continueWithGoogle')||""} />
                    {/* <FacebookLoginButton
                        onClick={() => {
                            signInWithFacebook()
                        }}
                        text="Kontynuj z Facebok" /> */}
                    <Collapse in={colapsed}>
                        <Button variant="text" onClick={() => setColapsed(!colapsed)}>{t('loginWithEmail')}</Button>
                    </Collapse>
                    <Collapse in={!colapsed}>
                        <CustomLogin privacyPolicyAccepted={privacyPolicyAccepted==='accepted'} setPrivacyPolicyError={()=>setPrivacyPolicyAccepted('error')} />
                    </Collapse>
                  <FormGroup sx={{mb:2}}>
                    <FormControlLabel
                      control={<Checkbox value={privacyPolicyAccepted==='accepted'} onClick={() => setPrivacyPolicyAccepted(privacyPolicyAccepted==='accepted'?'empty':'accepted')} />}
                      label={<>{t('privacy.accept')} <Link onClick={() => navigate("/privacyPolicy")}>{t('privacy.policy')}</Link></>}
                    />
                    {privacyPolicyAccepted==='error' && <Box maxWidth={'50lvw'} color="red">{t('privacy.error')}</Box>}

                  </FormGroup>


                  <I18Picker/>

                </Box>
            </Paper>
        </Box>
    );
}
export default Login;